import React from "react";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/media";

export const WhatsAppFloat = () => (
  <a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    aria-label="WhatsApp"
    className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-trise-terra text-trise-ivory shadow-lg shadow-black/20 hover:scale-110 transition-transform duration-300"
  >
    <MessageCircle size={26} />
  </a>
);
